var _g, _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUserTransport(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 43,
    viewBox: "0 0 43 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2372_4076)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4.73438,
    y: 0.195312,
    width: 34,
    height: 34,
    rx: 10,
    fill: "#F6EFE9"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.4141 10.6143C15.7541 10.6143 15.1941 11.0343 14.9941 11.6143L12.9141 17.6143V25.6143C12.9141 25.8795 13.0194 26.1338 13.207 26.3214C13.3945 26.5089 13.6488 26.6143 13.9141 26.6143H14.9141C15.1793 26.6143 15.4336 26.5089 15.6212 26.3214C15.8087 26.1338 15.9141 25.8795 15.9141 25.6143V24.6143H21.2141C21.0178 23.9656 20.9167 23.2919 20.9141 22.6143C20.9157 21.4048 21.2306 20.2163 21.8283 19.1648C22.4259 18.1133 23.2858 17.2345 24.3241 16.6143H14.9141L16.4141 12.1143H27.4141L28.5941 15.6443C29.2071 15.7082 29.8089 15.8527 30.3841 16.0743L28.8341 11.6143C28.6341 11.0343 28.0741 10.6143 27.4141 10.6143H16.4141ZM26.9141 17.6143C26.853 17.6131 26.7934 17.6335 26.7459 17.6719C26.6983 17.7104 26.6658 17.7643 26.6541 17.8243L26.4641 19.1443C26.1641 19.2743 25.8741 19.4343 25.6141 19.6143L24.3741 19.1143C24.2641 19.1143 24.1341 19.1143 24.0641 19.2443L23.0641 20.9743C23.0041 21.0843 23.0241 21.2143 23.1241 21.2943L24.1841 22.1143C24.1442 22.4464 24.1442 22.7821 24.1841 23.1143L23.1241 23.9343C23.0791 23.9728 23.0487 24.0255 23.0378 24.0837C23.0269 24.1419 23.0361 24.2021 23.0641 24.2543L24.0641 25.9843C24.1241 26.1143 24.2541 26.1143 24.3741 26.1143L25.6141 25.6143C25.8741 25.7943 26.1541 25.9643 26.4641 26.0843L26.6541 27.4043C26.6741 27.5243 26.7741 27.6143 26.9141 27.6143H28.9141C29.0241 27.6143 29.1341 27.5243 29.1541 27.4043L29.3441 26.0843C29.6441 25.9543 29.9141 25.7943 30.1841 25.6143L31.4141 26.1143C31.5441 26.1143 31.6741 26.1143 31.7441 25.9843L32.7441 24.2543C32.772 24.2021 32.7813 24.1419 32.7703 24.0837C32.7594 24.0255 32.729 23.9728 32.6841 23.9343L31.6141 23.1143C31.6341 22.9443 31.6541 22.7843 31.6541 22.6143C31.6541 22.4443 31.6441 22.2843 31.6141 22.1143L32.6741 21.2943C32.719 21.2557 32.7494 21.203 32.7604 21.1448C32.7713 21.0866 32.762 21.0265 32.7341 20.9743L31.7341 19.2443C31.6741 19.1143 31.5441 19.1143 31.4141 19.1143L30.1841 19.6143C29.9141 19.4343 29.6441 19.2643 29.3341 19.1443L29.1441 17.8243C29.1378 17.7673 29.1109 17.7146 29.0686 17.6759C29.0263 17.6373 28.9714 17.6154 28.9141 17.6143H26.9141ZM16.4141 18.6143C16.8119 18.6143 17.1934 18.7723 17.4747 19.0536C17.756 19.3349 17.9141 19.7164 17.9141 20.1143C17.9141 20.5121 17.756 20.8936 17.4747 21.1749C17.1934 21.4562 16.8119 21.6143 16.4141 21.6143C16.0162 21.6143 15.6347 21.4562 15.3534 21.1749C15.0721 20.8936 14.9141 20.5121 14.9141 20.1143C14.9141 19.7164 15.0721 19.3349 15.3534 19.0536C15.6347 18.7723 16.0162 18.6143 16.4141 18.6143ZM27.9141 21.1143C28.7441 21.1143 29.4141 21.7843 29.4141 22.6143C29.4141 23.4443 28.7441 24.1143 27.9141 24.1143C27.0741 24.1143 26.4141 23.4443 26.4141 22.6143C26.4141 21.7843 27.0841 21.1143 27.9141 21.1143Z",
    fill: "#8F4300"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2372_4076",
    x: 0.734375,
    y: 0.195312,
    width: 42,
    height: 42,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.970833 0 0 0 0 0.952226 0 0 0 0 0.952226 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2372_4076"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2372_4076",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserTransport);
export default __webpack_public_path__ + "static/media/User_transport.b5ede5e9935281d10b470c372504e981.svg";
export { ForwardRef as ReactComponent };